import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { computed } from "@vue/composition-api";
import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useAddress } from "@Shared/@Composables/generic/useAddress";
import { CLIENT_APPLICATION_STATUS } from "@Shared/js/enum";
import * as ApplicationStandAloneMutations from "@Client/@Modules/application-standalone/store/application-standalone-mutations";
import { useApplicationStandaloneStoreMutations } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { useI18n } from "vue-i18n-composable";
import { isEmpty } from "lodash";
export const useSummaryHelpers = () => {
  const {
    GET_FIELD_BY_PATH,
    GET_DISCLAIMERS,
    GET_ACCEPTED_CONSENTS,
    GET_APPLICATION_STATUS,
    APPLICATION_IS_LOCKED,
    GET_COAPPLICANT_STATUS
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_FIELD_BY_PATH, ApplicationStandaloneGetters.GET_DISCLAIMERS, ApplicationStandaloneGetters.GET_ACCEPTED_CONSENTS, ApplicationStandaloneGetters.GET_APPLICATION_STATUS, ApplicationStandaloneGetters.APPLICATION_IS_LOCKED, ApplicationStandaloneGetters.GET_COAPPLICANT_STATUS]);
  const {
    SET_ACCEPTED_CONSENTS
  } = useApplicationStandaloneStoreMutations([ApplicationStandAloneMutations.SET_ACCEPTED_CONSENTS]);
  const {
    allApplicants
  } = useApplicantHelpers();
  const {
    t,
    tc
  } = useI18n();
  const currentFlow = computed(() => {
    return GET_FIELD_BY_PATH.value("flow");
  });
  const purchasePrice = computed(() => GET_FIELD_BY_PATH.value("property.details.purchase-price"));
  const formattedAddress = computed(() => {
    const address = GET_FIELD_BY_PATH.value("property.details.address");
    return useAddress(address).fullAddress.value;
  });
  const propertyHasCompleteAddress = computed(() => {
    const address = GET_FIELD_BY_PATH.value("property.details.address");
    return useAddress(address).isAddressComplete.value;
  });
  const disclaimers = computed(() => GET_DISCLAIMERS.value);
  const applicationHasLiabilities = computed(() => allApplicants.value.some(({
    liabilities
  }) => liabilities && !!liabilities.length));
  const applicationHasIdentifications = computed(() => allApplicants.value.some(({
    identifications
  }) => identifications && !!identifications.length));
  const showDisclaimersSection = computed(() => {
    var _disclaimers$value;
    return ((_disclaimers$value = disclaimers.value) == null ? void 0 : _disclaimers$value.length) > 0;
  });
  const getCoApplicantStatus = computed(() => GET_COAPPLICANT_STATUS.value);
  const userCanSubmit = computed(() => {
    var _context;
    return !_includesInstanceProperty(_context = [CLIENT_APPLICATION_STATUS.submitted, CLIENT_APPLICATION_STATUS.inReview, CLIENT_APPLICATION_STATUS.completed]).call(_context, GET_APPLICATION_STATUS.value) || GET_COAPPLICANT_STATUS.value === "pending";
  });
  const updateAcceptedConsents = (disclaimer, isChecked) => {
    var _context2;
    const acceptedConsents = isChecked ? [...GET_ACCEPTED_CONSENTS.value, disclaimer] : _filterInstanceProperty(_context2 = GET_ACCEPTED_CONSENTS.value).call(_context2, ({
      id
    }) => id !== disclaimer.id);
    SET_ACCEPTED_CONSENTS(acceptedConsents);
  };
  const isConsentsAcceptedValid = computed(() => {
    var _disclaimers$value2;
    return (_disclaimers$value2 = disclaimers.value) == null ? void 0 : _disclaimers$value2.every(disclaimer => !disclaimer.mandatory || GET_ACCEPTED_CONSENTS.value.some(consent => consent.id === disclaimer.id));
  });
  const getTextForAddButton = (translationPath, infoToVerify = {
    iteratee: isEmpty,
    pathToVerify: "",
    singleValue: null
  }) => {
    if (infoToVerify.pathToVerify && infoToVerify.singleValue) throw new Error("You should only specify either pathToVerify or singleValue");
    const hasAtLeastOneItem = infoToVerify.pathToVerify ? allApplicants.value.some(applicant => infoToVerify.iteratee(applicant[infoToVerify.pathToVerify || ""])) : infoToVerify.iteratee(infoToVerify.singleValue);
    return tc(translationPath, Number(hasAtLeastOneItem != null ? hasAtLeastOneItem : 0) + 1);
  };
  const allowEdit = computed(() => !APPLICATION_IS_LOCKED.value);
  const editButtonText = computed(() => allowEdit.value ? t("global.words.edit") : t("global.actions.viewDetails"));
  return {
    currentFlow,
    purchasePrice,
    formattedAddress,
    disclaimers,
    propertyHasCompleteAddress,
    applicationHasIdentifications,
    applicationHasLiabilities,
    showDisclaimersSection,
    userCanSubmit,
    getCoApplicantStatus,
    isConsentsAcceptedValid,
    updateAcceptedConsents,
    getTextForAddButton,
    allowEdit,
    editButtonText
  };
};